import { AuthHeader } from '@auth/components/display/authHeader';
import { SplitLayout } from '@components/layout';
import { FormattedMessage } from 'react-intl';

type ErrorProps = {
    useVanillaComponents?: boolean;
    messages?: Record<string, string>;
};

const Error = ({ useVanillaComponents, messages = {} }: ErrorProps) => {
    return (
        <SplitLayout useVanillaComponents={useVanillaComponents}>
            <AuthHeader useVanillaComponents={useVanillaComponents} messages={messages} />
            <div className="mt-8 flex items-start bg-[#fdeded] text-[#5f2120] px-4 py-[6px] rounded-[4px]" role="alert">
                <svg
                    className="w-[22px] mr-3 py-[7px]"
                    focusable="false"
                    aria-hidden="true"
                    viewBox="0 0 24 24"
                    fill="#d74141"
                    data-testid="ErrorOutlineIcon"
                >
                    <path d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path>
                </svg>
                <div className="py-[7px]">
                    <div className="font-roboto font-medium text-base tracking-[.15px] leading-5 mt-[3px]">
                        {useVanillaComponents ? (
                            messages['error.somethingWentWrong'] || 'Whoops! Something went wrong!'
                        ) : (
                            <FormattedMessage
                                id="error.somethingWentWrong"
                                defaultMessage="Whoops! Something went wrong!"
                            />
                        )}
                    </div>
                    <div className="font-roboto text-sm tracking-[.17px] leading-5 mt-0.5 mb-0.5">
                        {useVanillaComponents ? (
                            messages['common.pleaseTryAgain'] || 'Please try again later.'
                        ) : (
                            <FormattedMessage id="common.pleaseTryAgain" defaultMessage="Please try again later." />
                        )}
                    </div>
                </div>
            </div>
        </SplitLayout>
    );
};

export { Error };
